import AuthService from "../login/auth.service";
import {cuentas } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class PerfilTransaccionalService {
  async perfiles() {
    

    var config = {
      method: "get",
      url: cuentas + "socio-cuenta/perfil-transaccional",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }
}
export default new PerfilTransaccionalService();
